import { ModuleProductOverviewFragment } from '@/graphql';
import { FC } from 'react';
import ProductOverview from '@/components/modules/ProductOverview';

interface ProductOverviewModuleProps {
  props: CraftModuleFragment<ModuleProductOverviewFragment>;
}

const ProductOverviewModule: FC<ProductOverviewModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  return <ProductOverview heading={props.heading ?? undefined} />;
};

export default ProductOverviewModule;
